import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
const API_URL = 'https://apis-csvc-v0-2faa314f421f.herokuapp.com' // <<== da sostituire con variabile d'ambiente in .env
// const API_URL = 'http://localhost:5700' // <<== da sostituire con variabile d'ambiente in .env



export const fetchElencoQuestionari = createAsyncThunk('elencoQuestionari/getElencoQuestionari', (endpoint) => {
    console.log ('fetchElencoQuestionari - endpoint: ', endpoint)

    return fetch(endpoint)
        .then(response => {
            if (!response.ok) throw Error(response.statusText)
            return response.json();
        })
        .then(json => json)
})


export const creaNuovoQuestionario = createAsyncThunk('questionari/creaNuovoQuestionario', async (updatedValues) => {

    // console.log('updateRilevanzaAmbiti - updatedValues: ', JSON.stringify(updatedValues))
    const endpoint = `${API_URL}/questionari`;
    // console.log('updateRilevanzaAmbiti - endpoint: ', endpoint)
  
    return fetch(endpoint, {
      method: 'POST',
      crossDomain: true,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(updatedValues)
    })
    .then(response => {
        if (!response.ok) throw Error(response.statusText)
        return response.json();
    })
    .then(json => json)
});
  

const elencoQuestionariSlice = createSlice({
    name:'elencoQuestionari',
    initialState: {
        test: 'OK-OK',
        numberOfItem: null,
        data: null,
        status: 'idle',
        error: null,
    },
    reducers: {
    },
    extraReducers: builder => {

        // createAsyncThunk #1 - fetchElencoQuestionari
        builder.addCase(fetchElencoQuestionari.pending,     (state) => {
            state.status = 'loading'
        })

        builder.addCase(fetchElencoQuestionari.fulfilled,   (state, action) => {
            state.status = 'succeded'
            state.data = action.payload         // from createAsyncThunk
            state.numberOfItem = action.payload.length
        })

        builder.addCase(fetchElencoQuestionari.rejected,    (state, action) => {
            state.loading = 'failed'
            state.error = action.error.message  // from createAsyncThunk    
        })


        // createAsyncThunk #2 - creaNuovoQuestionario
        builder.addCase(creaNuovoQuestionario.pending,     (state) => {
        state.status = 'loading'
        })

        builder.addCase(creaNuovoQuestionario.fulfilled,   (state, action) => {
            state.status = 'succeded'
        
            // Incrementare state.numberOfItem di 1 unità
            state.numberOfItem += 1;

            // Aggiungere all'array data un nuovo oggetto
            state.data.push({
                _id: action.payload._id,
                questionarioUuid: action.payload.questionarioUuid,
                utenteCsvcUuid: action.payload.utenteCsvcUuid,
                emailUsername: action.payload.emailUsername,
                aziendaNome: action.payload.aziendaNome,
                versioneQuestionario: action.payload.versioneQuestionario,
                statoLavorazione: action.payload.statoLavorazione
            });
  
        })

        builder.addCase(creaNuovoQuestionario.rejected,    (state, action) => {
            state.loading = 'failed'
            state.error = action.error.message  // from createAsyncThunk    
        })

    }   
})

export const elencoQuestionariReducer = elencoQuestionariSlice.reducer
